import * as utilities from "../src/utilities";

const site = "americanblinds";
const client = "blinds";
const publishPath = "prod";


let getPublishPath = function () {

	return publishPath;

};

let getClient = function () {

	return client;

};

let isProdDeployment = function () {

    let pubPath = getPublishPath();
	let client = getClient();
	let isProdDomain = ( window._satellite?.environment?.stage === "production" || location.hostname.indexOf( 'www' ) > -1 ) && client === 'blinds';

    if ( pubPath === 'prod' && isProdDomain ) {
        return true;
    }

    return false;

};

const getSAccount = function( ddo ) {

    let suitesSet = new Set();

	utilities.validateDataObj( ddo );

	if ( BUILD_TARGET === "americanblinds" ) {

		if ( isProdDeployment() ) {
			suitesSet.add( 'blindscenturyprod' );
		}
		else {
			suitesSet.add( 'blindsamericandevtest' );
		}

	}

	if ( BUILD_TARGET === "blinds" ) {

		if ( isProdDeployment() ) {
			suitesSet.add( 'blindsmaincom' );
		}
		else {
			suitesSet.add( 'blindscom1dev' );
		}

	}

	if ( BUILD_TARGET === "blindsca" ) {

		if ( isProdDeployment() ) {
			suitesSet.add( 'blindscamain' );
		}
		else {
			suitesSet.add( 'blindscadevtest' );
		}

	}

	if ( BUILD_TARGET === "justblinds" ) {

		if ( isProdDeployment() ) {
			suitesSet.add( 'blindsjustblindscom' );
		}
		else {
			suitesSet.add( 'blindscom2dev' );
		}

	}

	let uniqueSuites = Array.from( new Set( suitesSet ) );

	return uniqueSuites.join();

};

export {
    site,
    getPublishPath,
    getSAccount,
    getClient,
    isProdDeployment,
};
